<div class="row">
  <!--  <div class="col mb-5 ">
  <h3 class="mb-3 with-manual-link">
    <span i18n="@@approval">Freigabe</span>
    <app-manual-link href="/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Allgemein/Zugriff"></app-manual-link>
  </h3>
  <div class="row  align-items-center ">
    <div class="col col-lg-5">
      <span i18n="@@bot-sharing-by-link">Mit Link freigeben </span>
      @if (this.rss.botConfig.isPublic) {
        <app-hint
          i18n="@@bot-public-on-hint"
          ><b>Jeder</b> mit dem Link kann den Bot nutzen
        </app-hint>
      }
      @if (!this.rss.botConfig.isPublic) {
        <app-hint
          i18n="@@bot-public-off-hint"
          >Nur <b>angemeldete Benutzer</b> können den Bot nutzen</app-hint>
      }
      </div>
      <div class="col">
        <div class="btn-group btn-group-sm">
          <div
            class="btn btn-primary"
            [ngClass]="{
                          'btn-light':this.rss.botConfig.isPublic,
                          'btn-primary':!this.rss.botConfig.isPublic
                        }"
            (click)="this.rss.botConfig.isPublic = false; this.rss.botConfig.isPwProtected = false; this.rss.saveBotConfigField('isPublic');this.rss.saveBotConfigField('isPwProtected')"
            i18n="@@off"
          >Aus</div>
          <div
            class="btn btn-primary"
            [ngClass]="{
                          'btn-light':!this.rss.botConfig.isPublic,
                          'btn-primary':this.rss.botConfig.isPublic
                        }"
            (click)="this.rss.botConfig.isPublic = true; this.rss.saveBotConfigField('isPublic');"
            i18n="@@on"
          >An</div>
        </div>
      </div>
    </div>
    <div
      class="row align-items-center mt-3"
      [ngClass]="{' row-disabled ': !this.rss.botConfig.isPublic}"
      >
      <div class="col col-lg-5">
        <span i18n="@@instant-access">Instant Access Links zulassen</span>
        <app-hint i18n="@@pinstant-access-hint">
          Mit dem Instant Access kannst du individuelle Freigaben mithilfe eines Links erzeugen
        </app-hint>
      </div>
      <div class="col">
        <div class="btn-group btn-group-sm">
          <div
            class="btn btn-primary"
            [ngClass]="{
                      'btn-light':this.rss.botConfig.enableInstantAccess,
                      'btn-primary':!this.rss.botConfig.enableInstantAccess
                    }"
            (click)="this.rss.botConfig.enableInstantAccess = false; this.rss.saveBotConfigField('enableInstantAccess');"
            i18n="@@off"
          >Aus</div>
          <div
            class="btn btn-primary"
            [ngClass]="{
                      'btn-light':!this.rss.botConfig.enableInstantAccess,
                      'btn-primary':this.rss.botConfig.enableInstantAccess
                    }"
            (click)="this.rss.botConfig.enableInstantAccess = true; this.rss.saveBotConfigField('enableInstantAccess')"
            i18n="@@on"
          >An</div>
        </div>
      </div>
    </div>
    <div
      class="row align-items-center mt-3"
      [ngClass]="{' row-disabled ': !this.rss.botConfig.isPublic}"
      >
      <div class="col col-lg-5">
        <span i18n="@@protect-with-password">Links mit Passwort schützen</span>
        <app-hint
          *ngIf="this.rss.botConfig.isPwProtected"
          i18n="@@protect-with-password-on-hint"
          >
          Es liegt kein Passwortschutz vor. <b>Jeder</b> mit dem Link kann den Bot nutzen.
        </app-hint>
        <app-hint
          *ngIf="!this.rss.botConfig.isPwProtected"
          i18n="@@protect-with-password-off-hint"
          >
          Nur <b>angemeldete Benutzer und Nutzer mit Passwort</b> können den Bot nutzen
        </app-hint>
      </div>
      <div class="col">
        <div class="btn-group btn-group-sm">
          <div
            class="btn btn-primary"
            [ngClass]="{
                    'btn-light':this.rss.botConfig.isPwProtected,
                    'btn-primary':!this.rss.botConfig.isPwProtected
                  }"
            (click)="this.rss.botConfig.isPwProtected = false; this.rss.saveBotConfigField('isPwProtected');"
            i18n="@@off"
          >Aus</div>
          <div
            class="btn btn-primary"
            [ngClass]="{
                    'btn-light':!this.rss.botConfig.isPwProtected,
                    'btn-primary':this.rss.botConfig.isPwProtected
                  }"
            (click)="this.rss.botConfig.isPwProtected = true; this.setInitialPwWhenEmpty(); this.rss.saveBotConfigField('isPwProtected')"
            i18n="@@on"
          >An</div>
        </div>
      </div>
    </div>
    <div
      class="row align-items-center mt-3"
      [ngClass]="{' row-disabled': !this.rss.botConfig.isPwProtected}"
      >
      <div class="col col-lg-5">
        <span i18n="@@password">Passwort</span>
      </div>
      <div class="col">
        <input
          type="text"
          class="form-control form-control-sm"
          [(ngModel)]="this.rss.botConfig.botPassword"
          [ngModelOptions]="{updateOn: 'blur'}"
          (ngModelChange)="this.saveCustomPw()"
          >
      </div>
    </div>
    <app-template-and-demo-share-component *ngIf="this.loginService.hasSUPERAdmin()">
    </app-template-and-demo-share-component>
  </div> -->
</div>
<div class="row">
  <div class="col-12">
    <h3 i18n="@@user-access-control">Personalisierung</h3>
  </div>
  <div class="col-12 mt-2">
    <div class="d-flex flex-wrap align-items-center w-100 access-actions">
      <p-button
        size="small"
        severity="primary"
        [outlined]="true"
        (onClick)="addToUsersList()"
        i18n-label="@@add-approval"
        label="Neue Freigabe"
      ></p-button>
      <p-button
        size="small"
        severity="primary"
        [outlined]="true"
        icon="ri-arrow-down-s-line"
        iconPos="right"
        (onClick)="userImportPanel.toggle($event)"
        i18n-label="@@add-approval-from-bot"
        label="Aus Bot übernehmen"
      ></p-button>
      <!-- TODO: Convert library to PrimeNG TIRO -->
      <rag-excel-export
        [exportButton]="{ label: 'Nutzungsstatistik Export'}"
        [class]="'p-button p-button-sm p-button-outlined p-button-primary'"
        [config]="this.excelStatsExportConf"
        [data]="this.accessService.exportingStats"
      ></rag-excel-export>
      <rag-excel-import
        [importButton]="{ label: 'Freigaben Import'}"
        (import)="this.importUsers($event)"
        [class]="'p-button p-button-sm p-button-outlined p-button-primary'"
        [config]="this.excelImportConf"
      ></rag-excel-import>
      <rag-excel-export
        [exportButton]="{ label: 'Freigaben Export'}"
        [class]="'p-button p-button-sm p-button-outlined p-button-primary'"
        [config]="this.excelExportConf"
        [data]="this.accessService.exportingUsers"
      ></rag-excel-export>
      <p-popover
        #userImportPanel
        [dismissable]="true"
        [style]="{ width: '350px' }"
        appendTo="body"
      >
        <span
          class="dropdown-header"
          i18n="@@users-other-bots"
        >Nutzer aus anderen Bots</span>
        <div class="mt-2 mb-2">
          <input
            pInputText
            pSize="small"
            placeholder="Suche"
            i18n-placeholder="Search"
            fluid
            [(ngModel)]="this.accessService.filterBotByName"
          >
        </div>
        @for (addableBot of this.accessService.filteredselectableUserlistOfBots; track addableBot; let i = $index) {
        <div class="px-2">
          @if (i !== 20) {
          <div
            class="cursor-pointer p-2"
            [ngClass]="{'disabled': this.isUserAddingLoading}"
            (click)="this.addToUsersList(addableBot.users)"
          >
            <i
              class="ri-circle-fill"
              [ngStyle]="{'color': addableBot.color}"
            ></i>
            {{addableBot.botName | shorty: 25}} <span class="float-end">
              (<i class="ri-user-fill"></i>{{addableBot.users.length}})
            </span>
          </div>
          }
          @if (i === 20) {
          <div class="p-2 text-muted">...</div>
          }
        </div>
        }
      </p-popover>
      @if (this.isUserAddingLoading) {
      <div
        class="spinner-border spinner-border-sm text-primary"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
      }
    </div>
  </div>
</div>
@if (this.accessService.kiToolUserList.length > 0) {
<div class="mx-n5 mt-4">
  <p-table [value]="this.accessService.kiToolUserList">
    <ng-template #header>
      <tr valign="middle">
        <th
          class="text-center ps-5"
          width="10px"
        >
          <p-checkbox
            [ngModel]="selectedIncludesAllShown()"
            [binary]="true"
            (onChange)="changeAllSelected($event.checked)"
          ></p-checkbox>
        </th>
        <th width="25%">
          <input
            pInputText
            pSize="small"
            #search
            [(ngModel)]="this.accessService.searchString"
            fluid
            i18n-placeholder="@@search-ellipsis"
            placeholder="Filter..."
          >
        </th>
        <th
          width="25%"
          i18n="@@userlist-metadata"
        >Metadaten</th>
        <th
          colspan="2"
          class="pe-5"
        >
          <div class="table-header-usage">
            <span i18n="@@userlist-usage"> Nutzung</span>
            @if ( this.accessService.selectedUserIds) {
            <p-button
              size="small"
              severity="danger"
              [outlined]="true"
              (onClick)="confirmDelete()"
              [label]="this.accessService.selectedUserIds.length + ' ' + this.deleteLabel"
            ></p-button>
            }
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template #emptymessage>
      <tr>
        <td
          colspan="6"
          class="text-center"
          i18n="@@no-entries"
        >
          Keine Einträge
        </td>
      </tr>
    </ng-template>
    <ng-template
      #body
      let-user
      let-i="rowIndex"
    >
      <tr>
        <td class="text-center ps-5">
          <p-checkbox
            [ngModel]="this.accessService.selectedUserIds.includes(user._id)"
            [binary]="true"
            (onChange)="changeSelection(user._id)"
          ></p-checkbox>
        </td>
        <td>
          <input
            pInputText
            fluid
            [ngClass]="{'is-invalid': this.guestIdAlreadyInList(user.guestId)}"
            type="text"
            [(ngModel)]="user.guestId"
            [ngModelOptions]="{updateOn: 'blur'}"
            (ngModelChange)="this.accessService.updateUserInList(user)"
          >
          @if (this.guestIdAlreadyInList(user.guestId)) {
          <small
            class="text-danger"
            i18n="@@disallowed-user-duplication"
          >Mehrfachverwendung eines Nutzernamens nicht erlaubt</small>
          }
          @let otherBotsCount = this.accessService.getUserUsageCount(user.guestId) -1;
          @if (otherBotsCount === 1) {
          <small i18n="@@accessToOneBot">Zugriff auf einen weiteren Bot</small>
          }
          @if (otherBotsCount > 1) {
          <small i18n="@@accessToMultipleBot">Zugriff auf {{otherBotsCount}} weitere Bots</small>
          }
        </td>
        <td class="col-3">
          <textarea
            pInputTextarea
            fluid
            [(ngModel)]="user.metadata"
            [ngModelOptions]="{updateOn: 'blur'}"
            (ngModelChange)="this.accessService.updateUserInList(user)"
            placeholder="{&#10;  name: 'Max Mustermann'&#10;}"
          ></textarea>
        </td>
        @let chatLink = this.getLink(user._id, 'chat');
        @let audioLink = this.getLink(user._id, 'audio');
        @let videoLink = this.getLink(user._id, 'video');
        @let vegaLink = this.getLink(user._id, 'video-vega');
        <td>
          <div class="row linkrow">
            <div class="col-auto"><i class="ri-chat-ai-line"></i>&nbsp;
              {{ ('000' + user.stats.chat.length).slice(-3)}}
            </div>
            <div
              class="col text-truncate"
              style="width: 20px;"
            >
              <a
                class=" d-none  d-lg-block fake-link cursor-pointer"
                (click)="this.accessService.selectedUserIds = [user._id]; confirmOpenLink(openLinkModal)"
              >
                {{chatLink}}
              </a>
            </div>
            <div class="col-auto"><i
                class="ri-clipboard-fill text-muted "
                (click)="this.copyLink(chatLink)"
              ></i>
            </div>
          </div>
          <div class="row linkrow">
            <div class="col-auto">
              <i class="ri-voice-ai-line"></i>&nbsp;
              {{ ('000' + user.stats.audio.length).slice(-3)}}
            </div>
            <div
              class="col text-truncate"
              style="width: 20px;"
            >
              <a
                class="d-none  d-lg-block  fake-link cursor-pointer"
                (click)="this.accessService.selectedUserIds = [user._id]; confirmOpenLink(openLinkModal)"
              >
                {{audioLink}}
              </a>
            </div>
            <div class="col-auto"><i
                class="ri-clipboard-fill text-muted"
                (click)="this.copyLink(audioLink)"
              ></i>
            </div>
          </div>
          <div class="row linkrow">
            <div class="col-auto">
              <i class="ri-video-ai-line"></i>&nbsp;
              {{ ('000' + user.stats.avatar.length).slice(-3)}}
            </div>
            <div
              class="col text-truncate"
              style="width: 20px;"
            >
              <a
                class="d-none  d-lg-block fake-link cursor-pointer"
                (click)="this.accessService.selectedUserIds = [user._id]; confirmOpenLink(openLinkModal)"
              >
                {{videoLink}}
              </a>
            </div>
            <div class="col-auto">
              <i
                class="ri-clipboard-fill text-muted"
                (click)="this.copyLink(videoLink)"
              ></i>
            </div>
          </div>
          <div class="row linkrow">
            <div class="col-auto">
              <i class="ri-video-ai-line"></i>&nbsp;
            </div>
            <div
              class="col text-truncate"
              style="width: 20px;"
            >
              <a
                class="d-none  d-lg-block fake-link cursor-pointer"
                (click)="this.accessService.selectedUserIds = [user._id]; confirmOpenLink(openLinkModal)"
              >
                {{vegaLink}}
              </a>
            </div>
            <div class="col-auto">
              <i
                class="ri-clipboard-fill text-muted"
                (click)="this.copyLink(vegaLink)"
              ></i>
            </div>
          </div>
        </td>
        <td
          class="text-end pe-5  "
          width="30"
        >
          <p-menu
            #menu
            appendTo="body"
            [model]="this.getUserActionMenuItems(user._id)"
            [popup]="true"
          ></p-menu>
          <p-button
            [text]="true"
            [rounded]="true"
            [raised]="true"
            severity="secondary"
            icon="ri ri-more-2-fill"
            (onClick)="menu.toggle($event)"
          ></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
}
<ng-template #openLinkModal>
  <div class="modal-header">
    <span i18n="@@copyLink">Link Kopieren</span>
    <p-button
      [text]="true"
      [rounded]="true"
      icon="pi pi-times"
      (onClick)="modalRef?.hide()"
      ariaLabel="Close"
    ></p-button>
  </div>
  <div class="modal-body">
    <div [@.disabled]="true">
      <p-message severity="secondary">
        <i
          class="ri-alert-line ri-2x me-2"
          style="float: left;"
        ></i>
        <span i18n="@@openAccessLinkAsAdminHint">
          Wenn du als Administrator eingeloggt bist, öffne den Link bitte in einem <b>Inkognito-Tab</b>.
          Andernfalls
          wirst du automatisch aus dem Administrationsbereich ausgeloggt.
        </span>
      </p-message>
    </div>
    @if (this.accessService.selectedUserIds.length === 1 && this.accessService.selectedUserIds[0]) {
    @let chatLink = this.getLink(this.accessService.selectedUserIds[0], 'chat');
    @let audioLink = this.getLink(this.accessService.selectedUserIds[0], 'audio');
    @let videoLink = this.getLink(this.accessService.selectedUserIds[0], 'video');
    @let vegaLink = this.getLink(this.accessService.selectedUserIds[0], 'video-vega');
    <b i18n="@@chatbotLink">Chatbot-Link</b>
    <div class="row">
      <div class="col pe-0">
        <textarea
          pInputTextarea
          readonly
          fluid
        >{{chatLink}}
          </textarea>
      </div>
      <div class="col-auto">
        <i
          class="ri-clipboard-fill text-muted"
          (click)="copyLink(chatLink)"
        ></i>
      </div>
    </div>
    <b i18n="@@audiobotLink">Audiobot-Link</b>
    <div class="row">
      <div class="col pe-0">
        <textarea
          pInputTextarea
          readonly
          fluid
        >{{audioLink}}
          </textarea>
      </div>
      <div class="col-auto">
        <i
          class="ri-clipboard-fill text-muted"
          (click)="copyLink(audioLink)"
        ></i>
      </div>
    </div>
    <b i18n="@@avatarbotLink">Avatar Nova-Link</b>
    <div class="row">
      <div class="col pe-0">
        <textarea
          pInputTextarea
          readonly
          fluid
        >{{videoLink}}
          </textarea>
      </div>
      <div class="col-auto">
        <i
          class="ri-clipboard-fill text-muted"
          (click)="copyLink(videoLink)"
        ></i>
      </div>
    </div>
    <b i18n="@@avatarVegaLink">Avatar Vega-Link</b>
    <div class="row">
      <div class="col pe-0">
        <textarea
          pInputTextarea
          readonly
          fluid
        >{{vegaLink}}
          </textarea>
      </div>
      <div class="col-auto">
        <i
          class="ri-clipboard-fill text-muted"
          (click)="copyLink(vegaLink)"
        ></i>
      </div>
    </div>
    <br>
    }
  </div>
</ng-template>